import script from "./tokenListPageContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./tokenListPageContent.vue?vue&type=script&setup=true&lang=ts"

import "./tokenListPageContent.vue?vue&type=style&index=0&id=d24ba4da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d24ba4da"]])

export default __exports__